import React from 'react'
import { FormikProps, withFormik, Form } from 'formik'
import Input from '../../components/input'
import formValidation from './formValidation'
import { useTranslation } from 'react-i18next'

type SignUpProps ={
  onSubmit: (values: SignUpValues) => void
  children?: React.ReactNode
  name: string
  email: string
  password: string
}

type SignUpValues= {
  name: string
  email: string
  password: string
}

const InnerForm: React.FunctionComponent<
  SignUpProps & FormikProps<SignUpValues>
> = ({ values, errors, handleChange, handleBlur, touched, children }) => {
  const { t } = useTranslation()

  return (
    <div className='container-view plan-card top-card-primary  col-12 col-md-4'>
      <div className='container-title'>
        <h2 className='h2-title'>{`${t('REGISTER')}`}</h2>
        <span className='display-grid'>
          {`${t('HAVE_AN_ACCOUNT')}`}
          <a className='link' href='/login'>
            {`${t('LOGIN')}`}
          </a>
        </span>
      </div>
      <Form>
        <Input
          id='name'
          label={`${t('NAME')}`}
          type='text'
          value={values.name}
          onChange={handleChange}
          touched={touched.name}
          classNameInput='input'
          required={true}
          classNameLabel='label-left'
        />
        <Input
          id='email'
          label={`${t('EMAIL')}`}
          type='text'
          value={values.email}
          onChange={handleChange}
          touched={touched.email}
          classNameInput='input'
          required={true}
          classNameLabel='label-left'
        />
        <Input
          id='password'
          label={`${t('PASSWORD')}`}
          type='password'
          value={values.password}
          onChange={handleChange}
          touched={touched.password}
          classNameInput='input'
          required={true}
          classNameLabel='label-left'
          bottomSpace={false}
        />
        <div className='text-left'>
          <small className='rules-password'>{`${t('PASSWORD_RULES_1')}`}</small>
          <small className='rules-password'>{`${t('PASSWORD_RULES_2')}`}</small>
        </div>
        <div className='container-button'>
          <button className='button-second width-200' type='submit'>
            {`${t('SIGN_UP')}`}
          </button>
        </div>
      </Form>
    </div>
  )
}

const SignUpForm = withFormik<SignUpProps, SignUpValues>({
  mapPropsToValues: (props) => {
    const initialValues: SignUpValues = {
      name: props.name || '',
      email: props.email || '',
      password: props.password || '',
    }
    return { ...initialValues, ...props }
  },
  validationSchema: formValidation,
  handleSubmit(values: SignUpValues, { props }) {
    props.onSubmit(values)
  },
})(InnerForm)
export default SignUpForm
